import { IStackItemStyles, Stack } from "@fluentui/react";
import React from "react";
import { ContentBodyBreadcrumb } from "./ContentBodyBreadcrumb";
import { ContentBodyFilesFolders } from "./ContentBodyFilesFolders";
import { ContentBodySPSearchResults } from "./ContentBodySPSearchResults";
import { useSelector } from "react-redux";
import { RootState } from "../../src/taskpane/components/_v2/redux/storeMain";
import { ComponentTypes } from "../../src/taskpane/config/config";
import { ContentBodyLibraries } from "./ContentBodyLibraries";
import Loader from "../../src/taskpane/components/Loader";
import { ContentManagerHome } from "../Home/ContentManagerHome";
import { ExchangeContent } from "./Exchange/ExchangeContent";
import { LanguageContext } from "../../utilities/LocalizationModule";

const contentContainerStackItemStyles: IStackItemStyles = {
    root: {
        height: "calc(100vh - 50px)",
        maxWidth: "calc(100vw - 350px)"
    }
};

const contentContainerCollapsedStackItemStyles: IStackItemStyles = {
    root: {
        height: "calc(100vh - 50px)",
        maxWidth: "calc(100vw - 35px)"
    }
};

const channelContentContainerStackItemStyles: IStackItemStyles = {
    root: {
        height: "calc(100vh - 50px)",
        maxWidth: "100vw"
    }
};

export interface gridSelectedItems {
    items: any[],
    count: number
}

export interface IContentManagerBodyProps {
    isInTeamsChannelMode?: boolean;
}

export const ContentManagerBody = ({ isInTeamsChannelMode }: IContentManagerBodyProps) => {
    const languageStrings = React.useContext(LanguageContext);
    const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);
    const isContentLoading = useSelector((state: RootState) => state.contentManagerDirectory.isContentLoading);
    const isSideMenuCollapsed = useSelector((state: RootState) => state.contentManagerDirectory.isSideMenuCollapsed);
    const searchValue = useSelector((state: RootState) => state.contentManagerDirectory.searchValue);

    return (
        <Stack styles={isInTeamsChannelMode ? channelContentContainerStackItemStyles : isSideMenuCollapsed ? contentContainerCollapsedStackItemStyles : contentContainerStackItemStyles}>
            {isContentLoading
                ? <Loader label={languageStrings.Loading} />
                : (<>
                    {!currentDirectory && !searchValue.value && <ContentManagerHome />}

                    {(currentDirectory || searchValue.value) && <ContentBodyBreadcrumb isInTeamsChannelMode={isInTeamsChannelMode} />}

                    {!searchValue.value && currentDirectory && (currentDirectory.type == ComponentTypes.SharePointDocuments || currentDirectory.type === ComponentTypes.TessAccount || currentDirectory.type === ComponentTypes.TessProject) && <ContentBodyLibraries />}

                    {currentDirectory && currentDirectory.sharePointListId && <ContentBodyFilesFolders />}

                    {currentDirectory && currentDirectory.type == ComponentTypes.Exchange && <ExchangeContent />}

                    {searchValue.value && !currentDirectory?.sharePointListId && currentDirectory?.type !== ComponentTypes.Exchange && <ContentBodySPSearchResults searchValue={searchValue} />}
                </>
                )}
        </Stack>
    )
};